import { AUFDialogComponent } from './components/dialogs/AUFDialog/AUFDialog.component';
import { FermeService } from './../services/ferme.service';
import { TabParamTacheComponent } from './components/tabs/tabParamTache/tabParamTache.component';
import { TabUtilisateurComponent } from './components/tabs/tabUtilisateur/tabUtilisateur.component';
import { EchartsBarAnimationComponent } from './components/charts/dashboard/echarts-bar-animation.component';
import { ModificationRecetteComponent } from './components/dialogs/modificationRecette/modificationRecette.component';
import { PeriodeComponent } from './../pages/recette/recette-list/recette-item/periode/periode.component';
import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {
  NbActionsModule,
  NbCardModule,
  NbLayoutModule,
  NbMenuModule,
  NbRouteTabsetModule,
  NbSearchModule,
  NbSidebarModule,
  NbTabsetModule,
  NbThemeModule,
  NbUserModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NbProgressBarModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbStepperModule,
  NbButtonModule,
  NbInputModule,
  NbAccordionModule,
  NbDialogModule,
  NbWindowModule,
  NbListModule,
  NbToastrModule,
  NbAlertModule,
  NbSpinnerModule,
  NbRadioModule,
  NbSelectModule,
  NbTooltipModule,
} from '@nebular/theme';

import { NbSecurityModule } from '@nebular/security';

import {
  FooterComponent,
  HeaderComponent,
  SearchInputComponent,
  ThemeSettingsComponent,
  SwitcherComponent,
  LayoutDirectionSwitcherComponent,
  ThemeSwitcherComponent,
  ThemeSwitcherListComponent,
  ToggleSettingsButtonComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  EvaIconsPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  SampleLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { DEFAULT_THEME } from './styles/theme.default';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { ConsulationRecetteDialogComponent } from './components/dialogs/consulationRecetteDialog/consulationRecetteDialog.component';
import { TabModificationPeriodeComponent } from './components/tabs/tabModificationPeriode/tabModificationPeriode.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { TabActionsPasseesComponent } from './components/tabs/tabActionsPassees/tabActionsPassees';
import { TabCultureComponent } from './components/tabs/tabCulture/tabCulture.component';
import { TabSalleComponent } from './components/tabs/tabSalle/tabSalle.component';
import { ButtonRenderComponent } from './components/tabs/tabUtilisateur/test.component';

const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

const NB_MODULES = [
  NbCardModule,
  NbLayoutModule,
  NbTabsetModule,
  NbRouteTabsetModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NgbModule,
  NbSecurityModule, // *nbIsGranted directive,
  NbProgressBarModule,
  NbCalendarModule,
  NbCalendarRangeModule,
  NbStepperModule,
  NbButtonModule,
  NbListModule,
  NbToastrModule,
  NbInputModule,
  NbAccordionModule,
  NbDialogModule,
  NbWindowModule,
  NbAlertModule,
  NbSpinnerModule,
  NbRadioModule,
  NbSelectModule,
  NbTooltipModule,
  Ng2SmartTableModule,
  NgxEchartsModule,
];


const COMPONENTS = [
  SwitcherComponent,
  EchartsBarAnimationComponent,
  TabModificationPeriodeComponent,
  TabUtilisateurComponent,
  TabParamTacheComponent,
  TabActionsPasseesComponent,
  AUFDialogComponent,
  TabCultureComponent,
  TabSalleComponent,
  ConsulationRecetteDialogComponent,
  ModificationRecetteComponent,
  LayoutDirectionSwitcherComponent,
  ThemeSwitcherComponent,
  ThemeSwitcherListComponent,
  HeaderComponent,
  FooterComponent,
  PeriodeComponent,
  SearchInputComponent,
  ThemeSettingsComponent,
  OneColumnLayoutComponent,
  SampleLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  ToggleSettingsButtonComponent,
  ButtonRenderComponent
];

const ENTRY_COMPONENTS = [
  AUFDialogComponent,
  ConsulationRecetteDialogComponent,
  ModificationRecetteComponent,
  ThemeSwitcherListComponent,
  ButtonRenderComponent
];

const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  EvaIconsPipe,
];

const NB_THEME_PROVIDERS = [
  ...NbThemeModule.forRoot(
    {
      name: 'default',
    },
    [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME ],
  ).providers,
  ...NbSidebarModule.forRoot().providers,
  ...NbMenuModule.forRoot().providers,
  ...NbDialogModule.forRoot().providers,
  ...NbWindowModule.forRoot().providers,
  ...NbToastrModule.forRoot().providers,
];

@NgModule({
  imports: [...BASE_MODULES, ...NB_MODULES],
  exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES],
  declarations: [...COMPONENTS, ...PIPES],
  entryComponents: [...ENTRY_COMPONENTS],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: ThemeModule,
      providers: [...NB_THEME_PROVIDERS,
      ],
    };
  }
}
